import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function NotFoundRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/");
    window.location.reload();
  }, [navigate]);

  return null;
}

export default NotFoundRedirect;
